/** isSearchResult */
export const SET_IS_SEARCH_RESULT = (payload: boolean) => ({
    type: "SET_IS_SEARCH_RESULT",
    payload,
})
